import React, { useContext, useEffect } from "react";
import FlipCard from "../home/FlipCard";
import { ProductsContext } from "../../context/ProductsContext";

const CoursesLanding = ({ hideTitle }) => {
  const { getProducts } = useContext(ProductsContext);

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div id="courses" className="bg-light text-center">
      {!hideTitle && (
        <h2 className="bg-dark text-light py-5 h1">Elige tu modalidad</h2>
      )}
      {/*<CourseGrid mode={mode} landing={true} />*/}
      <div className="row">
        <div className="col-12 col-md-6">
          <FlipCard
            title="On demand"
            link="/ondemand"
            src="tbmcert-ondemand-2.jpg"
            mode="on-demand"
            priceNote="3 paquetes disponibles"
            subtitle="CERTIFÍCATE DESDE CASA, A TU RITMO"
            description="Una modalidad diseñada para que estudies a tu ritmo, en tus propios tiempos, con flexibilidad, atención de dudas y retroalimentación que acompañan tu proceso."
            short_description="Aprende en línea a tu propio ritmo de una forma práctica y divertida"
          />
        </div>
        <div className="col-12 col-md-6">
          <FlipCard
            title="En vivo"
            link="/live"
            src="tbmcert-live-2.jpg"
            mode="live"
            priceNote="Planes de pago disponibles"
            subtitle="3 DÍAS EN VIVO CON TUS MASTER COACHES + ACCESO A TU FORMACIÓN ON DEMAND"
            description="Comienza con 3 días de formación en vivo para aprender la metodología de manera cercana, recibir correcciones en directo y resolver dudas al momento. Después, complementa tu proceso con la parte on demand para profundizar en el contenido y avanzar con mayor flexibilidad."
            short_description="Una modalidad híbrida que integra 3 días intensivos en vivo con tus Master Coaches + 80 días on demand "
          />
        </div>
      </div>
    </div>
  );
};

export default CoursesLanding;
